import { combineReducers } from 'redux';
import room from './room';
import me from './me';
import producers from './producers';
import dataProducers from './dataProducers';
import peers from './peers';
import consumers from './consumers';
import dataConsumers from './dataConsumers';
import notifications from './notifications';
import recordAudio from './recordAudio';
import alert from './alert';
import user from './user';
import strapiToken from './strapiToken';
import messages from './messages';
import expressions from './expressions';
import selectPatientId from './selectPatientId';

const reducers = combineReducers({
    room,
    me,
    producers,
    dataProducers,
    peers,
    consumers,
    dataConsumers,
    notifications,
    recordAudio,
    alert,
    user,
    strapiToken,
    messages,
    expressions,
    selectPatientId,
});

export default reducers;
